import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import CareFacilityAudit from '../components/Admin/AdminReports/CareFacilityAudit';
function CarefacilityAuditPage() {
    return (
            <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} />
                </div>
            <div className="content-class">
                <CareFacilityAudit />
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
            </>
        );
}

export default CarefacilityAuditPage;